import React, { Component } from "react";
import { connect } from "react-redux";
import { getFeaturedProducts } from "../actions/productActions";
import { withTranslation } from 'react-i18next';
import ExtendedLink  from "../components/ExtendedLink";

class FeaturedProducts extends Component {
    componentDidMount() {
        this.props.getFeaturedProducts(null);
  }

  render() {
    const { t, featuredProducts, settings } = this.props;

      if (!featuredProducts || !featuredProducts.items || featuredProducts.items.length === 0) return <div />;

    var productsList = featuredProducts.items.map(product => (
        <li key={product.id}>
            <ExtendedLink to={`${settings.baseUrl}Products/${product.id}`}>{product.title}</ExtendedLink>
        <span>
          ({settings.currencySymbol}
          {product.specialPrice})
        </span>
      </li>
    ));

    return (
      <div className="col-lg-3">
        <button
          className="sidebar-toggle position-left"
          data-toggle="modal"
          data-target="#modalShopCategories"
        >
          <i className="icon-layout"> </i>
        </button>
        <aside className="sidebar sidebar-offcanvas">
          <section className="widget widget-categories">
                    <h3 className="widget-title"> {t("Featured Products")}</h3>
            <ul>{productsList}</ul>
          </section>
        </aside>
      </div>
    );
  }
}

function mapStateToProps({ featuredProducts, settings }) {
  return { featuredProducts, settings };
}

export default withTranslation()(connect(mapStateToProps, { getFeaturedProducts })(
  FeaturedProducts
));
